export enum IndicationType {
  Unset = 0,
  StudyModelSmileDesign = 1,
  AlignerRetainerModel = 2,
  RemovableDieModel = 3,
  ModelCustomBleachingTray = 4,
  OcclusalGuard = 5,
  SurgicalGuide = 6,
  TryInDenture = 7,
  DentureBase = 8,
  HybridDenture = 9,
  DentureTeeth = 10,
  Crown = 11,
  Castable = 12,
  GingivaMask = 13,
  InlayAndOnlay = 14,
  IndirectBondingTray = 15,
  CustomImpressionTray = 16,
  Bridge = 17,
  SmileDesignSnapOn = 18,
  Veneer = 19,
  ImplantCrown = 20,
  Retainer = 21,
  AnteriorCrown = 22,
  Scan = 24,
  Restorations = 25,
  SportsGuard = 26,
  DuoMode = 27,
  Die = 28,
  DentalModels = 29,
  ImplantBridge = 30,
  PartialDentureBase = 31,
  Bitescan = 34,

  Upperscan = 101,
  Lowerscan = 102,
}
